import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { TopBar } from "./components/TopBar";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { TrustBar } from "./components/TrustBar";
import { ProblemSection } from "./components/ProblemSection";
import { ServicesSection } from "./components/ServicesSection";
import { WhySection } from "./components/WhySection";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { SocialProof } from "./components/SocialProof";
import { CoverageSection } from "./components/CoverageSection";
import { CTASection } from "./components/CTASection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      <HeroSection />
      <TrustBar />
      <ProblemSection />
      <ServicesSection />
      <WhySection />
      <GuaranteeSection />
      <SocialProof />
      <CoverageSection />
      <CTASection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
